import moment from "moment";
import React, { Component } from "react";
import PropTypes from "prop-types";
import withStyles from "@material-ui/core/styles/withStyles";
import { map } from "lodash";
import Assignment from "@material-ui/icons/Assignment";
import ECCard from "components/EnergyCompany/Cards/ECCard.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import InfoIcon from "@material-ui/icons/Info";
import Table from "components/Table/Table.jsx";
import Tooltip from "@material-ui/core/Tooltip";
import { localeString } from "services/utils";
import lightTooltipStyle from "assets/EnergyCompany/jss/lightTooltip";

const styles = theme => ({
  tableWrapper: {
    marginTop: "30px",
  },
  ...lightTooltipStyle(theme),
});

class TabelaBalanco extends Component {
  getTableData = () => {
    const { balancoDados } = this.props;

    return map(balancoDados, (data, month) => (
      [
        moment(month).format("MMM Y"),
        localeString(data.consumoLiquido),
        localeString(data.perdasConsumo),
        localeString(data.consumo),
        localeString(data.comprasSemProinfa),
        localeString(data.proinfa),
        localeString(data.vendas),
        localeString(data.saldoContratos),
        localeString(data.saldo),
      ]
    ));
  };

  getHeaderTooltip = (header, title) => {
    const { classes } = this.props;

    return (
      <Tooltip
        classes={{ popper: classes.lightTooltipPopper, tooltip: classes.lightTooltip }}
        placement="top"
        title={title}
      >
        <span className={classes.tooltipContentWrapper}>
          {header} <InfoIcon />
        </span>
      </Tooltip>
    );
  }

  getTableHead = () => {
    return [
      "Mês",
      "Consumo Líq.",
      "Perdas",
      this.getHeaderTooltip("Consumo Bruto", "Consumo Líq. + Perdas"),
      "Compras",
      "PROINFA",
      "Cessão",
      this.getHeaderTooltip("Net Contratos", "Compras + PROINFA - Cessão"),
      "Saldo",
    ];
  };

  render() {
    const { classes } = this.props;

    return (
      <GridContainer>
        <GridItem md={12} sm={12} xs={12}>
          <ECCard
            content={(
              <div className={classes.tableWrapper}>
                <Table
                  tableData={this.getTableData()}
                  tableHead={this.getTableHead()}
                  tableHeaderColor="primary"
                />
              </div>
            )}
            icon={<Assignment />}
            title="Balanço"
          />
        </GridItem>
      </GridContainer>
    );
  }
};

TabelaBalanco.propTypes = {
  balancoDados: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
};

export { TabelaBalanco as TabelaBalancoComponent };
export default withStyles(styles)(TabelaBalanco);



// WEBPACK FOOTER //
// ./src/views/Dashboard/partials/TabelaBalanco.jsx